import * as React from 'react';

const HappyLoaderSVG = ({ width =160 , height =160 , radius =70 , ...props })=>{
    return React.createElement("svg", {
        width: width,
        height: height,
        ...props
    }, React.createElement("circle", {
        cx: width / 2,
        cy: height / 2,
        r: radius
    }));
};

export { HappyLoaderSVG };
